import { Text } from '@factorialco/deprecated-design-system'

interface SimpleLabelProps {
  label: string
}

export const SimpleLabel = ({ label }: SimpleLabelProps) => (
  <Text.Normal color="grey700" size="100">
    {label}
  </Text.Normal>
)
